import type { RouteObject } from "react-router";
import AddSession from "./ui/pages/AddSession";
import Session from "./ui/pages/Session";
import GuestMeetingPage from "./ui/pages/GuestMeetingPage";
import MeetingSessionPage from "./ui/pages/MeetingSessionPage";

/**
 * Routes that carry a live call. Deliberately outside `AppLayout`: a session in
 * progress should not be sharing the screen with the app's own navigation, and
 * the sidebar is the first thing to go.
 */
export const meetingRoutes: RouteObject[] = [
    { path: "/meet/session/:sessionId", element: <MeetingSessionPage /> },
];

/**
 * How a patient attends: from the link and nothing else. Public by design —
 * the token in the URL is the authorisation, so requiring a sign-in here would
 * only be asking someone to prove twice that they were invited.
 */
export const guestMeetingRoutes: RouteObject[] = [
    { path: "/meet/j/:token", element: <GuestMeetingPage /> },
];

export const sessionRoutes: RouteObject[] = [
    { path: "/sessions/new", element: <AddSession /> },
    { path: "/session/:id", element: <Session /> },
];
